import React, { useContext, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import Typography from '../../../../components/common/Typography';
import { formatTime, getAlertMessageFunction } from '../../../../common/Util';
import { certifyEnd, checkSMS, sendSMS } from '../../resultQuerySlice';
import { getCertifyFlag } from '../../../common/commonSlice';
import AlertContext from '../../../../context/AlertContext';

const SMS = ({ modalCloseHandler, isOpen, htmSendUrlType }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('resultQuery');
  const { t: tCommon } = useTranslation('common');

  const { alertActions } = useContext(AlertContext);
  const { alertMessage } = alertActions;

  const { myInfo } = useSelector(state => state.myInfo);
  const [time, setTime] = useState(300);
  const [htmCertKey, setHtmCertKey] = useState('');

  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    sendSMSHandler();
  }, []);

  useEffect(() => {
    if (htmCertKey !== '') {
      checkSMSHandler();
      intervalRef.current = setInterval(() => {
        setTime(prevTime => prevTime - 1);
      }, 1000);
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [htmCertKey]);

  useEffect(() => {
    if (time == 0) {
      alertMessage(tCommon('alertMessage.smsFail'));
      modalCloseHandler();
    }
  }, [time]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  //인증번호 전송
  const sendSMSHandler = async () => {
    try {
      const response = await dispatch(
        sendSMS({
          htmSendUrlType: htmSendUrlType,
          htmInsaPerHTel: myInfo.htmInsaPerHTel || '',
          htmInsaPerEMail: myInfo.htmInsaPerEMail || '',
          htmPerNm: myInfo.htmInsaPerNm || '',
        }),
      ).unwrap();

      const { htmCertKey } = response;
      if (htmCertKey) setHtmCertKey(htmCertKey);
      else alertMessage(tCommon('alertMessage.fail'));
    } catch (error) {
      alertMessage(tCommon('alertMessage.fail'));
    }
  };

  //문자 인증체크
  const checkSMSHandler = async () => {
    try {
      const response = await dispatch(
        checkSMS({
          htmCertKey: htmCertKey,
        }),
      ).unwrap();

      const { htmIsCert } = response;
      if (htmIsCert == 'Y') {
        const endResponse = await dispatch(
          certifyEnd({
            htmCertifyKey: htmCertKey,
          }),
        ).unwrap();
        if (endResponse?.resultCode == '1') {
          alertMessage(tCommon('alertMessage.smsSuccess'));
          //인증다시 부르기
          dispatch(getCertifyFlag());

          modalCloseHandler();
        }
      } else {
        timeoutRef.current = setTimeout(() => {
          checkSMSHandler();
        }, 1500);
      }
    } catch (error) {
      alertMessage(tCommon('alertMessage.smsFail'));
    }
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={modalCloseHandler} title={t('signItem2')}>
      <div className="SMSContainer">
        <div className="SMSTitle">
          <Typography variant="body2Bold" color="Primary-500">
            {t('signItem5')}
          </Typography>
          <Typography variant="subtitleBold">{t('smsModal.description')}</Typography>
        </div>
        {/* 남은시간 */}
        <div className="SMSTimeBox">
          <Typography variant="body1Bold" color="Support-Pink">
            {t('smsModal.time')} {formatTime(time)}
          </Typography>
        </div>
        <div className="SMSContainer__message">
          <Typography
            variant="body2Medium"
            color="GrayScale-700"
            style={{ whiteSpace: 'pre-wrap' }}>
            {t('smsModal.message')}
          </Typography>
        </div>
      </div>
    </SlideRightDialog>
  );
};

export default SMS;
